"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _helper = require("./helper");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var JUMBO_LS_KEY = '__jumbo__';

var Storage = function Storage() {
  _classCallCheck(this, Storage);

  this.hydrateMemoryFromLocalStorage = function () {
    try {
      if ((0, _helper.isLocalStorageSupported)()) {
        var string_events = window.localStorage.getItem(JUMBO_LS_KEY);
        var saved_events_arr = '';

        if (string_events) {
          saved_events_arr = JSON.parse(string_events);

          if ((0, _helper.isArray)(saved_events_arr)) {
            window.jumbo = saved_events_arr.concat(window.jumbo ? window.jumbo : []);
          }
        }

        window.localStorage.removeItem(JUMBO_LS_KEY);
      }
    } catch (e) {
      (0, _helper.ravenLog)('Jumbo Error - hydrateMemoryFromLocalStorage - ' + e);
    }
  };

  this.getEventsArr = function () {
    return (0, _helper.isArray)(window.jumbo) ? window.jumbo.slice(0) : [];
  };

  this.addEventsArr = function (events) {
    if ((0, _helper.isArray)(events)) {
      window.jumbo = ((0, _helper.isArray)(window.jumbo) ? window.jumbo : []).concat(events);
    }
  };

  this.saveEventsArr = function (events) {
    if ((0, _helper.isLocalStorageSupported)()) {
      window.localStorage.setItem(JUMBO_LS_KEY, JSON.stringify(events));
    }
  };

  this.clear = function () {
    window.jumbo = [];
  };

  this.hydrateMemoryFromLocalStorage();
};

exports["default"] = Storage;